'use strict'

export let norwegian={
  general: {
    executive: "Eier",
    sro: "Eier",
    projectManager: "Prosjektleder",
    programmeManager: "Programleder",
    risks:"Riski",
    issues :"Saker"
  },
  reports: {
    heading: "Genererte rapporter",
    highlightReport: "Siste statusrapport",
    endProjectReport: "Sluttrapport",
    brief: "Prosjektforslag",
    pid: "Styringsdokument"
  },
  link: {
    heading: "Lenker",
    edit: {
      textPlaceholder: "Visningstekst",
      addressPlaceholder: "Adresse"
    },
    save: "OK",
    cancel: "Avbryt",
    exitEdit: "Avslutt editering",
    add: "Legg til lenke",
    goToProduct: "Gå til produkt"
  },
  keyInformation: {
    keyInformation: "Nøkkelinformasjon",
    identifier: "Identifikator",
    projectStage: "Etappe"
  },

  status: {
    summaryStatus: "Oppsummert status",
    portfolio: "Portefølje",
    numberOfProjects: "# Aktiviteter",
    priority: "Prioritet",
    name: "Navn",
    status: "Status",
    stage: "Del",
    benefits: "Gevinst",
    time: "Tid",
    cost: "Kostnad",
    quality: "Kvalitet",
    scope: "Omfang",
    risk: "Risiko"
  },
  themes: {
    background: {
      title: "Bakgrunn"
    },
    definition: {
      title: "Definisjon",
    },
    businessCase: {
      title: "Begrunnelse",
    },
    quality: {
      title: "Kvalitet",
    },
    organization: {
      title: "Organisation",
    },
    risk: {
      title: "Risiko",
    },
    plan: {
      title: "Planer",
    },
    change: {
      title: "Endring",
    },
    progress: {
      title: "Fremdrift",
    }
  },
  startupProcess: {
    title: "Anbefalte aktiviteter ved oppstart av prosjektet:",
    help: `Klikk på en aktivitet under for å utføre den. Hver aktivitet vil fylle ut en del av prosjektetforslaget. Du trenger ikke å fullføre alle aktiviteter for
      å gå videre og ha prosjektforslaget godkjent, men du bør sørge for at det er tilstrekkelig informasjon til å sikre at prosjektet er levedyktig og
      lønnsomt.`,
    activities: {
      appointExecutiveAndPM: {
        title: "Utnevne prosjekteier og prosjektleder",
        help: `Velg en beslutningstaker, prosjekteier, med riktig myndighet til å lede prosjektstyret, og angi prosjektleder for dette prosjektet. Alle prosjekter må ha en eier fra begynnelsen. Prosjekteieren er den ansvarlig for prosjektet.`
      },
      captureLessons: {
        title: "Fange opp erfaringer",
        help: `Gjennomgå erfaringer fra tidligere prosjekter for å identifisere erfaringer som kan brukes på dette prosjektet. Rådfør deg med personer med erfaring fra tidligere eller lignende prosjekter og skriv inn de relevante erfaringer som er identifisert.`
      },
      appointManagementTeam: {
        title: "Utforme og utnevne prosjektledelsen",
        help: `Identifiser ansvarlige for alle rollene i prosjektstyret, sikrings-rollene, støtte-rollene og teamlederrollene. Prosjektledelsen må gjenspeile interessene som vil være involvert, inkludert forretnings-, bruker- og leverandørinteresser. Det er viktig å ha de riktige personene i de aktuelle rollene og sikre at ansvar er godt forstått.`
      },
      prepareOutlineBusinessCase: {
        title: "Skissere begrunnelsen for prosjektet",
        help: `Prosjekteieren bør utarbeide begrunnelsen for prosjektet med hvorfor prosjektet er verdt å gjennomføre. Skissen vil på dette tidspunktet i prosjektet være overordnet og vil detaljeres ytterligere i neste etappe.`
      },
      defineProject: {
        title: "Definere prosjektet",
        help: `Gjennom dialog med sentrale interessenter noterer du ned prosjektmål, omfang, begrensninger, forutsetninger, interessenter og grensesnitt for prosjektet.`
      },
      describeProjectProduct: {
        title: "Beskrive prosjektets produkt",
        help: `Prosjektleder bør rådføre seg med seniorbruker, seniorleverandør og prosjekteier for å definere hva prosjektet skal levere. For hvert omfangselement angis hva som skal overleveres til linjeorganisasjonen når prosjektet er ferdig. Tenk bredt for å fange alle hovedleveransene, ikke dypt for å fange mange krav. Endre og juster omfanget ("Definere prosjektet") om nødvendig for å få strukturen til å fungere.`
      },
      selectApproach: {
        title: "Velge prosjekttilnærming",
        help:`Dokumenter avgjørelser om hvordan arbeidet i prosjektet skal gjøres. Avklar med seniorleverandør hvor hensiktsmessige ressurser kommer fra, om bestemte arbeidsmetoder skal benyttes, om gitt rammebetingelser vil gjelde og om spesifikke teknologier vil bli brukt.`
      },
      planInitiation: {
        title: "Planlegge initieringsetappen",
        help: `Lag en etappeplan for "planleggingen av prosjektet". Legg til en etappe som representerer arbeidet som trengs for å forstå og dokumentere tilnærminger for prosjektet og overordnet plan. Dette er vanligvis den første etappen i prosjektet og dekker prosessen "Initiering".`
      },
      assembleBrief: {
        title: "Opprette utkast av prosjektforslaget til gjennomgang",
        help: `Når tilstrekkelig informasjon er samlet for å godkjenne prosjektet og for å forstå grensene for planlegging av prosjektet, bør det opprettes et utkast av prosjektforslaget som presenteres for prosjektstyret til godkjenning. Etappeplan for Initiering skal også presenteres og godkjennes av prosjektstyret.`
      }
    },
    nextStep: {
      title: "Godkjenne prosjektforslaget"
    }
  },
  initiationProcess: {
    title: "Anbefalte aktiviteter ved initiere et prosjekt:",
    help: `Klikk på en aktivitet under for å utføre den. Hver aktivitet vil fylle ut en del av styringsdokumentet. Du trenger ikke å fullføre
alle aktivitetene for å gå videre og få godkjent styringsdokumentet, men du bør sørge for at det er tilstrekkelig informasjon til
å sikre at prosjektet har et solid grunnlag for gjennomføringen.`,
    activities: {
      prepareRiskManagementApproach : {
        title: "Utforme tilnærming til risikoledelse",
        help:"Tilnærming for risikostyring beskriver hvordan risikoen skal styres og hvilket risikonivå som er akseptabelt. Hva skal vi gjøre for at graden av usikkerhet håndteres?"
      },
      prepareQualityManagementApproach: {
        title: "Utforme kvalitetstilnæming",
        help: `Tilnærming for kvalitetshåndtering beskriver hvordan kvalitet sikres i prosjektet, inkludert styring av krav. Hva skal vi gjøre for å sikre at prosjektets produkter er "egnet til formålet"?`
      },
      prepareConfigurationManagementApproach: {
        title: "Utforme tilnærming til endringskontroll",
        help: `Tilnærming til endringskontroll beskriver hvordan endringer og problemer som oppstår vil bli administrert. Hva skal vi gjøre for å sikre at vi har tilstrekkelig kontroll på endringer?`
      },
      prepareCommunicationManagementApproach: {
        title: "Utforme tilnærming for kommunikasjon",
        help: `Tilnærming for kommunikasjon beskriver hvordan informasjon deles i prosjektgruppen og hvordan prosjektgruppen sender informasjon til og mottar informasjon fra prosjektinteressenter`
      },
      setupProjectControls: {
        title: "Sette opp prosjektkontroll",
        help: `Prosjektkontroll definerer hvordan prosjektstyret vil opprettholde nok kontroll over prosjektet og hvordan prosjektlederen skal opprettholde tilstrekkelig kontroll over arbeidet som forvaltes av teamledere.`
      },
      createProjectPlan: {
        title: "Opprette prosjektplan",
        help: `Etabler en plan på høyt plan som er brutt ned i etapper. For hver etappe definerer du hva som skal leveres, hvor mye tid du trenger og hva den anslåtte kostnaden er. Sørg for at du forstår prosjektledelsens forventning om ønsket detaljnivå og forutsigbarhet, og ikke kast bort tid på å gå inn i flere detaljer enn nødvendig.`
      },
      refineBusinessCase: {
        title: "Forfine prosjektbegrunnelsen",
        help: `Prosjekteier bør gi bergunnelsen for hvorfor prosjektet er verdt å gjennomføre`
      },
      defineProject: {
        title: "Se igjennom prosjektdefinisjonen",
        help: `Gjennom dialog med viktige interessenter oppdaterer og bekrefter du prosjektmål, omfang, begrensninger, forutsetninger, interessenter og grensesnitt.`
      },
      describeProjectProduct: {
        title: "Revider beskrivelsen av prosjektets produkt",
        help: `Prosjektleder bør rådføre seg med seniorbruker, seniorleverandør og prosjekteier for å oppdatere hva prosjektet skal levere. For hvert omfangselement angis hva som overleveres til linjeorganisasjonen når prosjektet er ferdig. Tenk bredt for å fange alle hovedleveransene, ikke dypt for å fange mange krav. Endre og juster omfanget ("Definer prosjektet") om nødvendig for å få strukturen til å fungere.`
      },
      selectApproach: {
        title: "Gjennomgå prosjekttilnærmingen",
        help: `Oppdater avgjørelser om hvordan arbeidet i prosjektet skal gjøres. Avklar med seniorleverandør hvor hensiktsmessige ressurser kommer fra, om bestemte arbeidsmetoder skal benyttes, om gitt rammebetingelser vil gjelde og om spesifikke teknologier vil bli brukt.`
      },
      assemblePID: {
        title: "Opprette utkast av styringsdokument til gjennomgang",
        help: `Når tilstrekkelig informasjon er samlet og tilstrekkelig planlegging er utført for å starte gjennomføringen av prosjektet, bør det opprettes et utkast til styringsdokument (PID) som presenteres til prosjektstyret for godkjenning. Etappelanen for neste etappe skal også presenteres og godkjennes av prosjektstyret.`
      }
    },
    nextStep: {
      title: "Godkjenne styringsdokumentet"
    }
  },
  closeProcess: {
    title: "Anbefalte aktiviteter før prosjektet avsluttes:",
    help: `Før det anbefales at prosjektet avsluttes, bør prosjektleder oppdatere styringsdokumentet og prosjektplanen, oppdatere erfaringene,
lukke åpne saker og risiko, og utarbeide en sluttrapport. Sørg også for å informere alle interessentene.`,
    activities: {
      acceptProducts: {
        title: "Aksepter produktene"
      },
      createLessons: {
        title: "Samle erfaringer",
        help: "Samarbeid prosjektledelsen for å identifisere og dokumentere erfaringer som kan brukes i fremtidige prosjekter."
      },
      createEndProjectReport: {
        title: "Opprett sluttrapport",
        help: "Vurder hvor vellykket prosjektet har vært og oppsummer konklusjonene i sluttprosjektrapporten."
      },
      closeRiskRegister: {
        title: "Lukk åpne risiki",
        help: "Lukk alle åpne risiki. Før en risiko lukkes, vurder om den skal overføres til et annet risikoregister, for eksempel på program eller produktnivå"
      },
      closeIssueRegister: {
        title: "Lukk åpne saker",
        help: "Lukk alle åpne saker. Før en sak avsluttes, vurder om den skal overføres til et annet saksregister, for eksempel på program eller produktnivå"
      },
      recommendClosure: {
        title: "Anbefal avslutning av prosjektet",
        help: "Når alle avsluttende aktiviteter er gjennomført, bør en innstilling om prosjektavslutning sendes til styringsgruppen."
      }
    },
    nextStep: {
      title: "Godkjenn avslutning av prosjektet"
    },
    cancel: {
      title: "Avbryt prosjektavslutning"
    }
  },
  clone: {
    noName: "Klone av"
  }
};



// WEBPACK FOOTER //
// ./views/project/labels/norwegian.js